import { buildDashboardState } from '../studioDashboardUtils.js'
import { DashboardView } from './uiDashboard.jsx'
import {
  fmtDateTime,
  getPillar,
  RUNTIME_CHECK_LABELS,
} from './studioConstants.js'
import { S, btn } from './uiStyles.js'
import { UI_THEME } from './uiTheme.js'
import contentTypeUtils from '../contentTypeUtils.js'

const { getContentType } = contentTypeUtils

export function DashboardTab({
  posts,
  ideas,
  projects,
  positions,
  archivedPosts,
  archivedIdeas,
  researchBriefs,
  reports,
  publishAttempts,
  runtimeVerifications,
  integrationHealth,
  startDate,
  authorityReview,
  authorityReviews,
  authorityTopicCandidates,
  authorityCoverage,
  strategicAssets,
  strategicAssetCoverage,
  authorityReviewLoading,
  onRunAuthorityReview,
  onOpenResumeItem,
  onOpenTab,
}) {
  const dashboard = buildDashboardState({
    posts,
    ideas,
    projects,
    positions,
    archivedPosts,
    archivedIdeas,
    researchBriefs,
    reports,
    publishAttempts,
    runtimeVerifications,
    integrationHealth,
    authorityReview,
    authorityReviewLoading,
    authorityTopicCandidates,
    strategicAssets,
    strategicAssetCoverage,
  })

  return (
    <DashboardView
      dashboard={dashboard}
      posts={posts}
      ideas={ideas}
      publishAttempts={publishAttempts}
      runtimeVerifications={runtimeVerifications}
      integrationHealth={integrationHealth}
      startDate={startDate}
      authorityReview={authorityReview}
      authorityReviews={authorityReviews}
      authorityTopicCandidates={authorityTopicCandidates}
      authorityCoverage={authorityCoverage}
      strategicAssets={strategicAssets}
      strategicAssetCoverage={strategicAssetCoverage}
      authorityReviewLoading={authorityReviewLoading}
      onRunAuthorityReview={onRunAuthorityReview}
      onOpenResumeItem={onOpenResumeItem}
      onOpenTab={onOpenTab}
      fmtDateTime={fmtDateTime}
      getContentType={getContentType}
      getPillar={getPillar}
      RUNTIME_CHECK_LABELS={RUNTIME_CHECK_LABELS}
      UI_THEME={UI_THEME}
      S={S}
      btn={btn}
    />
  )
}
